const getters = {
    loginStatusPending: state => state.loginInfo.status.pending,
    showError: state => state.showError,
    userInfo: state => state.userInfo,
    registerInfo: state => state.registerInfo,
    registerStatusPending: state => state.registerInfo.status.pending,
    emailUnbestaetigt: state => state.emailUnbestaetigt,
}

export default getters;